import React, { useState, useEffect, useContext, useMemo } from "react";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import TextInput from "components/Input/TextInput.js";
import AddIcon from "@mui/icons-material/Add";
import {
  CustomSelect,
} from "components/Input/Index.js";
import uuid from "react-uuid";
import Button from "@mui/material/Button";
import { makeStyles, withStyles } from "@mui/styles";
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import DataTable from "react-data-table-component";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import EditButton from "components/CustomButtons/Button.js";
import styled from "styled-components";
import { dico } from "variables/lists/dico";
import { charttext } from "variables/chart";
import {
  typesdata, granularitydata, typestimedata, typesnotimedata, distributiondata,
  distributiongroupmentdata, typescomposedchart,
  indicatorserietypedata, chartaxisData, datatypedata, chartcolors, serieaggdata,
  heatmapdisplaydata, heatmapcolordata
} from "variables/lists/charts";
import AutocompleteInputMeters from "components/Input/AutocompleteInputMeters.js";
import { Divider } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import Tooltip from "@mui/material/Tooltip";
import CustomSwitch from "components/Input/CustomSwitch.js";
import FloatInput from "components/Input/FloatInput";
import IntInput from "components/Input/IntInput.js";
import TextInputUn from "components/Input/TextInputUn";
import FloatInputUn from "components/Input/FloatInputUn";
import AppBar from "@mui/material/AppBar";
import TabContext from "@mui/lab/TabContext";
import TabPanel from "@mui/lab/TabPanel";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import CustomDialogTitle from "components/Dialog/CustomDialogTitle.js";
import ImageList from "@mui/material/ImageList";
import EmbeddedEntitesTree from "components/MenuEntites/EmbeddedEntitesTree";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import UserService from "services/UserService";
import axios from "axios";
import { putChartV2, postChartV2, getMBMEquipments } from "services/ConfigServices";
import { NotificationManager } from "react-notifications";
import AddValueToFormula from "./AddValueToFormula";
import Chip from "@mui/material/Chip";
import Dialog from "@mui/material/Dialog";
import AdvancedDefDialogRealestate from "components/RTCharts/AdvancedDefDialogRealestate";
import AdvancedDefDialogIndic from "components/RTCharts/AdvancedDefDialogIndic";
import AdvancedDefDialogPoint from "components/RTCharts/AdvancedDefDialogPoint";
import AdvancedDefDialogEquipmentDatatype from "components/RTCharts/AdvancedDefDialogEquipmentDatatype";
import EditIcon from "@mui/icons-material/Edit";
import EquipmentsDialog from "./EquipmentsDialog";

const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px',
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '8px',
  },
}))(MuiDialogActions);

const useStyles2 = makeStyles(styles);
const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      //width: "30ch",
    },
  },
  formControl: {
    margin: 8,
    width: "62ch",
  },
  gridList: {
    width: "100%",
    height: "calc(100vh - 335px)",
    margin: "5px",
  },
  gridListParam: {
    width: "100%",
    height: "calc(100vh - 346px)",
    margin: "5px",
    overflowX: "auto"
  },
  treeVisible: {
    display: "block",
  },
  treeHidden: {
    display: "none",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "0px",
    marginRight: "auto",
    marginLeft: "auto",
    width: "60ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "0px",
    marginRight: "auto",
    marginLeft: "auto",
    width: "60ch",
  },
  padding: {
    padding: '0px',
  },
  demo2: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
  demo3: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
}));

const StyledTabs = withStyles({
  indicator: {
    display: "flex",
    justifyContent: "center",
    backgroundColor: "transparent",
    "& > span": {
      maxWidth: 80,
      width: "100%",
      backgroundColor: "#91C73C",
    },
  },
})((props) => <Tabs {...props} TabIndicatorProps={{ children: <span /> }} />);

const StyledTab = withStyles((theme) => ({
  root: {
    textTransform: "none",
    color: "#000",
    fontWeight: 400,
    fontFamily: '"Source Sans Pro",sans-serif',
    fontSize: '0.9375rem',
    marginRight: '8px',
    minWidth: "auto",
    display: "flex",
    fullWidth: true,
    "&:focus": {
      opacity: 1,
    },
  },
}))((props) => <Tab disableRipple {...props} />);

const UploadButton = styled.div`
  margin-left: 0px;
  &:hover {
    cursor: pointer;
  }
`;
const NoData = styled.p`
  font-size: 14px;
  font-weight: 600;
  margin-top: 20px;
  opacity: 1;
`;
const TableName = styled.h1`
  margin-right: auto;
  margin-left: -8px;
  font-size: 1.1rem;
  font-weight: 400;

`;
const Container = styled.div`
  border-bottom: 0.5px solid rgba(0, 0, 0, 0.15);
  border-top: 4px solid rgba(255, 255, 255, 1);
  background-color: white;
  margin-top: -0.5px;
`;
const TreeLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  opacity: 1;
  font-family: "Source Sans Pro", sans-serif;
`;
const Separator = styled.div`
border-bottom: 1px solid #a8a8a8;
height: 2px;
margin-bottom: 0.6rem;
margin-left: 0.8rem;
margin-right: 0.8rem;
margin-top: 0.6rem;
`;
const FormulaDiv = styled.div`
min-height: 50px;
background: white;
border: solid;
border-width: 1px;
border-color: rgb(189 189 189 / 87%);
border-radius: 4px;
padding: 6px;
margin: 7px;
`;

const FormulaText = styled.span`
  font-size: 14px;
  opacity: 1;
  margin: 5px;
  vertical-align: middle;
  letter-spacing: 1px!important;
`;
const EquipmentsLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  opacity: 1;
  font-family: "Source Sans Pro", sans-serif;
  padding-top: 5px;
  margin-right: 8px;
`;
const EquipmentsDiv = styled.div`
  font-size: 14px;
  display: flex;
  margin-top: 16px;
  margin-bottom: 10px;
`;

function ChartDialogV2(props) {
  const currentusertype = localStorage.getItem('userType');
  const { closeModal, currentchart, refetch, setLoading, indicatordata, pointdata, realestatedata, avalaibleDico } = props;
  const advancedSearchContext = useContext(AdvancedSearchContext);
  const { chartIdGroup } = advancedSearchContext;

  const [value, setValue] = useState("0");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  console.log('test');

  const [name, setName] = useState(currentchart?.parameters.name || "");
  const [tooltip, setTooltip] = useState(currentchart?.parameters.tooltip || "");
  const [type, setType] = useState(currentchart?.parameters.type || "indicatorchart");
  const [xaxisscale, setXaxisscale] = useState(currentchart?.parameters.xaxisscale || "");
  const [granularity, setGranularity] = useState(currentchart?.parameters.xaxistimetick || "day");
  const [yaxis2, setYaxis2] = useState(currentchart?.parameters.yaxis2 || 0);
  const [yaxis1unit, setYaxis1unit] = useState(currentchart?.parameters.yaxis1unit || "");
  const [yaxis2unit, setYaxis2unit] = useState(currentchart?.parameters.yaxis2unit || "");
  const [defaultoccupationschedule, setDefaultoccupationschedule] = useState(currentchart?.parameters.defaultoccupationschedule || false);
  const [groups, setGroups] = useState(currentchart?.accountid ? "" + currentchart.accountid : "");
  const [distribution, setDistribution] = useState(currentchart?.parameters.distribution || "no");
  const [distributiongroupment, setDistributiongroupment] = useState(currentchart?.parameters.distributiongroupment || "");

  const [lowerisbetter, setLowerisbetter] = useState(currentchart?.parameters.indicatorparameters?.lowerisbetter || false);
  const [gaugemin, setGaugemin] = useState(currentchart?.parameters.indicatorparameters?.gauge?.min || 0);
  const [gaugemax, setGaugemax] = useState(currentchart?.parameters.indicatorparameters?.gauge?.max || 100);
  const [gaugesegmentscount, setGaugesegmentscount] = useState(currentchart?.parameters.indicatorparameters?.gauge?.segments?.length || "");
  const [gaugesegments, setGaugesegments] = useState(currentchart?.parameters.indicatorparameters?.gauge?.segments || []);

  const [heatmapdisplay, setHeatmapdisplay] = useState(currentchart?.parameters.heatmapparameters?.heatmapdisplay || "hourday");
  const [heatmapcolor, setHeatmapcolor] = useState(currentchart?.parameters.heatmapparameters?.heatmapcolor || "bluered");

  const [displaytotal, setDisplaytotal] = useState(currentchart?.parameters.tabparameters?.displaytotal || false);
  const [targetequipments, setTargetequipments] = useState(currentchart?.parameters.tabparameters?.targetequipments || []);
  const [openEquipments, setOpenEquipments] = useState(false);
  const [equipmentdata, setEquipmentdata] = useState([]);
  const [fullpointdata, setFullpointdata] = useState([]);
  const [equipmentdatatype, setEquipmentatatype] = useState([]);

  const [series, setSeries] = useState([]);
  const [definitiondata, setDefinitiondata] = useState([]);
  const [points, setPoints] = useState([]);
  const [buttonDisabled, setButtonDisabled] = useState(true);
  const [currentdef, setCurrentdef] = useState("");
  const [currentFormulapretty, setCurrentFormulapretty] = useState("");
  const [currentSerie, setCurrentSerie] = useState("");
  const [open, setOpen] = useState(false);
  const [openpoint, setOpenpoint] = useState(false);
  const [openeqdatatype, setOpeneqdatatype] = useState(false);
  const [openrealestate, setOpenrealestatet] = useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleEditClose = () => {
    setOpen(false);
  };
  const handleClickOpenpoint = () => {
    setOpenpoint(true);
  };
  const handleEditClosepoint = () => {
    setOpenpoint(false);
  };
  const handleClickOpeneqdatatype = () => {
    setOpeneqdatatype(true);
  };
  const handleEditCloseeqdatatype = () => {
    setOpeneqdatatype(false);
  };
  const handleClickOpenrealestate = () => {
    setOpenrealestatet(true);
  };
  const handleEditCloserealestate = () => {
    setOpenrealestatet(false);
  };

  /**equipments */
  const handleCloseEquipments = () => {
    setOpenEquipments(false);
  };
  const handleClickOpenEquipments = () => {
    setOpenEquipments(true);
  };
  useEffect(() => {
    //equipments
    if (type === 'tabequipment' && groups) {
      axios
        .get(
          getMBMEquipments(groups, 'all'),
          {
            headers: {
              Authorization: `Bearer ${UserService.getToken()}`,
            },
          }
        )
        .then((res) => {
          setEquipmentdata(res.data.equipments || []);
          setFullpointdata(res.data.points || []);
        })
        .catch(() => { });
    }
  }, [groups, type]);
  const editEquipments = () => async () => {
    handleClickOpenEquipments();
  }


  /**chart */
  const handleNameChange = (event) => { setName(event.target.value); };
  const handleTooltipChange = (newvalue) => { setTooltip(newvalue); };
  const handleTypeChange = (event) => {
    setType(event.target.value);
    let tmpseries = series || [];
    if (event.target.value === 'column' || event.target.value === 'composedchart') {
      tmpseries.forEach((serie) => {
        if (!serie.stackId)
          serie.stackId = 'Pile 1';
      });
      setSeries(tmpseries);
    }
    if (event.target.value === 'tab' || event.target.value === 'tabequipment') {
      setGranularity("day");
    }
    if (event.target.value === 'heatmap') {
      setGranularity("hour");
      setHeatmapdisplay("hourday");
      setYaxis2unit("");
      setYaxis2(0);
      setDistribution("no");
      if (tmpseries.length > 1) {
        let newseries = [];
        newseries.push(tmpseries.at(0));
        setSeries(newseries);
      }
    }
  };

  const handleHeatmapdisplayChange = (event) => {
    if (event.target.value === 'hourday')
      setGranularity("hour");
    else if (event.target.value === 'dayweek')
      setGranularity("day");
    else if (event.target.value === 'daymonth')
      setGranularity("day");
    else if (event.target.value === 'monthyear')
      setGranularity("month");
    setHeatmapdisplay(event.target.value);
  };
  const handleHeatmapcolorChange = (event) => { setHeatmapcolor(event.target.value); };

  const handleGranularityChange = (event) => { setGranularity(event.target.value); };
  const handleYaxis1unitChange = (event) => { setYaxis1unit(event.target.value); };
  const handleYaxis2Change = (event) => {
    if (yaxis2)
      setYaxis2(0);
    else
      setYaxis2(1);
  };
  const handleYaxis2unitChange = (event) => { setYaxis2unit(event.target.value); };
  const handleDefaultoccupationscheduleChange = (event) => {
    setDefaultoccupationschedule(!defaultoccupationschedule);
  };
  const handleXaxisscaleChange = (event) => {
    if (xaxisscale === 'time') {
      setXaxisscale("");
      if (!typesnotimedata.find((type) => type.id === type)) {
        setType(typesnotimedata[0].id);
      }
    }
    else {
      setXaxisscale("time");
      if (!typestimedata.find((type) => type.id === type)) {
        setType(typestimedata[0].id);
      }
    }
  };
  const handleDistributionChange = (event) => { 
    if(event.target.value === 'no')
    {
      setDistributiongroupment('no');
    }
    setDistribution(event.target.value); 
  };
  const handleDistributiongroupmentChange = (event) => { setDistributiongroupment(event.target.value); };

  const handleLowerisbetterChange = (event) => { setLowerisbetter(!lowerisbetter); };
  const handleGaugeminChange = (event) => { setGaugemin(event.target.value); };
  const handleGaugemaxChange = (event) => { setGaugemax(event.target.value); };
  const handleGaugesegmentscountChange = (event) => {
    let gaugesegmentscounttmp = event.target.value;
    if (gaugesegmentscounttmp < 2)
      gaugesegmentscounttmp = 2;
    else if (gaugesegmentscounttmp > 9)
      gaugesegmentscounttmp = 9;
    setGaugesegmentscount(gaugesegmentscounttmp);
    let segmentstmp = [...gaugesegments];
    if (segmentstmp.length > gaugesegmentscounttmp) {
      segmentstmp.splice(gaugesegmentscounttmp);
    }
    let i = 0;
    for (i; i < gaugesegmentscounttmp; i++) {
      if (segmentstmp.length <= i) {
        segmentstmp.push({ color: "url(#colorGreen)", min: gaugemin, max: gaugemax, shortname: "Segment " + i, name: "" + i })
      }
    }
    setGaugesegments(segmentstmp);
  };
  const handleGaugesegmentsChange = (event, index, param) => {
    let segmentstmp = [...gaugesegments];
    segmentstmp[index][param] = event.target.value;
    setGaugesegments(segmentstmp);
  }


  const handleDisplaytotalChange = (event) => { setDisplaytotal(!displaytotal); };

  /**series */
  const handleSerieNameChange = (event, serie) => {
    serie.name = event.target.value;
    let newseries = [...series];
    let seriemodif = newseries.find((o) => o.uuid === serie.uuid);
    seriemodif.name = event.target.value;
    setSeries(newseries);
  };
  const handleColorChange = (event, serie) => {
    serie.color = event.target.value;
    let newseries = [...series];
    let seriemodif = newseries.find((o) => o.uuid === serie.uuid);
    seriemodif.color = event.target.value;
    setSeries(newseries);
  };
  const handleSerieAggChange = (event, serie) => {
    serie.serieagg = event.target.value;
    let newseries = [...series];
    let seriemodif = newseries.find((o) => o.uuid === serie.uuid);
    seriemodif.serieagg = event.target.value;
    setSeries(newseries);
  };
  const handleDatatypeChange = (event, serie) => {
    serie.datatype = event.target.value;
    let newseries = [...series];
    let seriemodif = newseries.find((o) => o.uuid === serie.uuid);
    seriemodif.datatype = event.target.value;
    setSeries(newseries);
  };
  const handleAxisChange = (event, serie) => {
    serie.yaxis = event.target.value;
    let newseries = [...series];
    let seriemodif = newseries.find((o) => o.uuid === serie.uuid);
    seriemodif.yaxis = event.target.value;
    setSeries(newseries);
  };
  const handleSerieTypeChange = (event, serie) => {
    serie.type = event.target.value;
    let newseries = [...series];
    let seriemodif = newseries.find((o) => o.uuid === serie.uuid);
    seriemodif.type = event.target.value;
    if (event.target.value === 'column' && !seriemodif.stackId) {
      seriemodif.stackId = 'Pile 1';
    }
    setSeries(newseries);
  };
  const handleSerieStackChange = (event, serie) => {
    serie.stackId = event.target.value;
    let newseries = [...series];
    let seriemodif = newseries.find((o) => o.uuid === serie.uuid);
    seriemodif.stackId = event.target.value;
    setSeries(newseries);
  };

  const handleFormulaChange = (newvalue, serie) => {
    parseFormula(newvalue, serie, series, true)
  };

  useEffect(() => {
    let tmpseries = currentchart?.parameters?.series || [];
    let position = 1;
    tmpseries.forEach((serie) => {
      if (!serie.uuid)
        serie.uuid = uuid();
      if (!serie.position)
        serie.position = position;
      else
        position = serie.position;
      position++;
      parseFormula(serie.formula, serie, tmpseries, false);
    });
    setSeries(tmpseries);


  }, []);

  useEffect(() => {
    console.log(targetequipments);
    if (targetequipments) {
      let tmpdatatype = [];
      targetequipments.forEach((eq) => {
        let eqpoints = fullpointdata.filter((p) => p.equipment == eq.id);
        eqpoints.forEach((pt) => {
          if (!tmpdatatype.find((dt) => dt.id === pt.definition)) {
            let type = dico.find((d) => d.id == pt.definition);
            if (type) {
              tmpdatatype.push({ id: pt.definition, unit: type.unit, name: type.equipmentname + " - " + type.name, equipmentcount: 1 });
            }
          }
          else {
            tmpdatatype.find((dt) => dt.id === pt.definition).equipmentcount++;
          }
        });
      });
      setEquipmentatatype(tmpdatatype);
    }

  }, [targetequipments, fullpointdata]);

  useEffect(() => {
    let tmpdefinitiondata = dico.filter((item) =>
      points.find((x) => x.definition == item.id)
    );
    setDefinitiondata(tmpdefinitiondata);
  }, [points]);
  useEffect(() => {
    if (!yaxis2 && series.length > 0) {
      let newseries = [...series];
      newseries.forEach((serie) => {
        serie.yaxis = 'left';
      });
      setSeries(newseries);
    }
  }, [yaxis2]);

  const classes = useStyles();
  const classes2 = useStyles2();

  const handleSubmit = (event) => {
    if (currentchart?.id)
      updateChart(event);
    else
      createChart(event);
  };

  const createChart = async (event) => {
    let newseries = [...series];
    newseries.forEach((serie) => {
      serie.formulapretty = ""; //we dont want to save that
    });
    let newchart = {
      parameters: {
        name,
        tooltip,
        type,
        xaxisscale,
        xaxistimetick: granularity,
        yaxis2,
        yaxis1unit,
        yaxis2unit,
        defaultoccupationschedule,
        series: newseries,
        distribution,
        distributiongroupment,
      },
      accountid: groups
    };
    if (type === 'indicatorchart') {
      let newindicatorparameters = {
        lowerisbetter,
        gauge: {
          min: gaugemin,
          max: gaugemax,
          segments: gaugesegments
        }
      };
      newchart.parameters.indicatorparameters = newindicatorparameters;
    }
    if (type === 'tab' || type === 'tabequipment') {
      let newtabparameters = {
        displaytotal,
      };
      if (type === 'tabequipment') {
        newtabparameters.targetequipments = targetequipments;
      }
      newchart.parameters.tabparameters = newtabparameters;
    }
    if (type === 'heatmap') {
      let newheatmapparameters = {
        heatmapcolor,
        heatmapdisplay
      };
      newchart.parameters.heatmapparameters = newheatmapparameters;
    }
    axios
      .post(
        postChartV2(),
        newchart
        ,
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          NotificationManager.success("Graphique créé");
          refetch();
          closeModal();
        } else NotificationManager.error("Une erreur est survenue");
      })
      .catch((error) => {
        NotificationManager.error("Une erreur est survenue");
        setLoading(false);
      });
  };

  const updateChart = async (event) => {
    let newseries = [...series];
    newseries.forEach((serie) => {
      serie.formulapretty = ""; //we dont want to save that
    });
    let newchart = {
      ...currentchart,
      parameters: {
        ...currentchart.parameters,
        name,
        tooltip,
        type,
        xaxisscale,
        xaxistimetick: granularity,
        yaxis2,
        yaxis1unit,
        yaxis2unit,
        defaultoccupationschedule,
        series: newseries,
        distribution,
        distributiongroupment
      },
      accountid: groups
    };
    if (type === 'indicatorchart') {
      let newindicatorparameters = {
        ...currentchart.parameters.indicatorparameters,
        lowerisbetter,
        gauge: {
          min: gaugemin,
          max: gaugemax,
          segments: gaugesegments
        }
      };
      newchart.parameters.indicatorparameters = newindicatorparameters;
    }
    if (type === 'tab' || type === 'tabequipment') {
      let newtabparameters = {
        ...currentchart.parameters.tabparameters,
        displaytotal,
      };
      if (type === 'tabequipment') {
        newtabparameters.targetequipments = targetequipments;
      }
      newchart.parameters.tabparameters = newtabparameters;
    }
    if (type === 'heatmap') {
      let newheatmapparameters = {
        ...currentchart.parameters.newheatmapparameters,
        heatmapcolor,
        heatmapdisplay
      };
      newchart.parameters.heatmapparameters = newheatmapparameters;
    }

    axios
      .put(
        putChartV2(currentchart.id),
        newchart
        ,
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          NotificationManager.success("Graphique modifié");
          refetch();
          closeModal();
        } else NotificationManager.error("Une erreur est survenue");
      })
      .catch((error) => {
        NotificationManager.error("Une erreur est survenue");
        setLoading(false);
      });
  };




  useEffect(() => {
    if ((!name || !type))
      setButtonDisabled(true);
    else
      setButtonDisabled(false);
  }, [name, type, granularity]);

  const seriesColumns = [
    {
      name: charttext.position,
      selector: (row) => row.position,
      sortable: true,
      maxWidth: "6rem",
      cell: (row) => row.position,
    },
    {
      name: charttext.color,
      selector: (row) => row.color,
      sortable: true,
      maxWidth: "10rem",
      omit: type === 'heatmap',
      cell: (row) => row.color ? chartcolors.find((a) => a.id == row.color)?.name || "" : ""
    },
    {
      name: charttext.seriename,
      selector: (row) => row.name,
      sortable: true,
      cell: (row) => row.name
    },
    {
      name: "",
      sortable: false,
      width: "12rem",
      cell: (row) => (
        <>
          <div className="actions-right">
            <Tooltip title="Monter la position">
              <EditButton
                onClick={upSerie(row)}
                color={"info"}
                className={classes2.actionButton}
                disabled={row.position == 1}
              >
                <ArrowDropUpIcon fontSize="large" />
              </EditButton>
            </Tooltip>
            <Tooltip title="Descendre la position">
              <EditButton
                onClick={downSerie(row)}
                color={"info"}
                className={classes2.actionButton}
                disabled={row.position == series.length}
              >
                <ArrowDropDownIcon fontSize="large" />
              </EditButton>
            </Tooltip>
            <Tooltip title="Supprimer la série de la vue">
              <EditButton
                onClick={deleteSerieFromChartFunction(row)}
                color={"danger"}
                className={classes2.actionButton}
              >
                <DeleteIcon fontSize="large" />
              </EditButton>
            </Tooltip>
          </div>
        </>
      ),
    },
  ]

  const upSerie = (row) => async () => {
    let newseries = [...series];
    let obj = newseries.find((o) => o.uuid === row.uuid);
    let oldposition = obj.position;
    let newposition = oldposition - 1; //ie 3 -> 2
    let replacedserie = newseries.find((o) => o.position === newposition);
    obj.position = newposition;
    replacedserie.position = oldposition;
    setSeries(newseries);
  }

  const downSerie = (row) => async () => {
    let newseries = [...series];
    let obj = newseries.find((o) => o.uuid === row.uuid);
    let oldposition = obj.position;
    let newposition = oldposition + 1; //ie 3 -> 4
    let replacedserie = newseries.find((o) => o.position === newposition);
    obj.position = newposition;
    replacedserie.position = oldposition;
    setSeries(newseries);
  }

  const deleteSerieFromChartFunction = (row) => async () => {
    let deletedposition = series.find((o) => o.uuid === row.uuid).position;
    let newseries = series.filter((o) => o.uuid !== row.uuid);
    for (let i = deletedposition + 1; i <= newseries.length + 1; i++) {
      let serie = newseries.find((o) => o.position === i);
      if (serie)
        serie.position = i - 1;
    }
    setSeries(newseries);
  };

  const addSerieToChartFunction = () => {
    let newseries = [...series];
    let newserie = {};
    newserie.uuid = uuid();
    newserie.name = "Nouvelle série";
    newserie.position = newseries.length + 1;
    newserie.axis = 'left';
    newserie.color = 'url(#colorRed)'
    newserie.stackId = 'Pile 1';
    newserie.type = 'column';
    newseries.push(newserie);
    setSeries(newseries);
  }

  const parseFormula = (formula, serie, series, updateseries) => {
    let formulatmp = formula;
    let formulaprettytmp = [];
    let updateformulapretty = true;
    let currentindex = 0;
    let formulaprettyobjectindex = 0;
    while (formulatmp) {
      currentindex = 0;
      if (formulatmp.includes("{")) {
        let stringendindex = formulatmp.indexOf("{");
        if (stringendindex > currentindex) {
          formulaprettytmp.push(formulatmp.substring(currentindex, stringendindex));
        }
        formulatmp = formulatmp.substring(formulatmp.indexOf("{"));
        if (formulatmp.startsWith("{I,")) {
          if (formulatmp.includes("}")) {
            let fullindicdef = formulatmp.substring(formulatmp.indexOf("{I,"), formulatmp.indexOf("}") + 1);
            let indicdef = formulatmp.substring(formulatmp.indexOf("{I,") + 3, formulatmp.indexOf("}")).split(",");
            let indicid;
            let agregatg = 'SUM';
            let replacebyzero = false;
            let decalage;
            let filter;
            if (indicdef.length > 0) {
              indicid = indicdef[0];
              if (indicdef.length > 1) {
                agregatg = indicdef[1];
                if (indicdef.length > 2) {
                  replacebyzero = indicdef[2];
                  if (indicdef.length > 3) {
                    decalage = indicdef[3];
                    if (indicdef.length > 3) {
                      filter = indicdef[4];
                    }
                  }
                }
              }
            }
            let indicname = indicatordata?.find((indic) => indic.id == indicid)?.name || "Inconnu";
            let granularity = indicatordata?.find((indic) => indic.id == indicid)?.timeresolution || "";


            currentindex = formulatmp.indexOf("}") + 1;
            formulaprettytmp.push({ type: 'indic', id: formulaprettyobjectindex, name: indicname, indicid, agregatg, replacebyzero, decalage, filter, granularity });
            formulaprettyobjectindex++;
            formulatmp = formulatmp.substring(formulatmp.indexOf("}") + 1);
          }
          else {
            updateformulapretty = false;
            break;
          }
        }
        else if (formulatmp.startsWith("{P,")) {
          if (formulatmp.includes("}")) {
            let fullpointdef = formulatmp.substring(formulatmp.indexOf("{P,"), formulatmp.indexOf("}") + 1);
            let pointdef = formulatmp.substring(formulatmp.indexOf("{P,") + 3, formulatmp.indexOf("}")).split(",");
            let pointid;
            let agregatg = 'SUM';
            let replacebyzero = false;
            let decalage;
            let filter;
            let granularity = 'auto';
            if (pointdef.length > 0) {
              pointid = pointdef[0];
              if (pointdef.length > 1) {
                granularity = pointdef[1];
                if (pointdef.length > 2) {
                  agregatg = pointdef[2];
                  if (pointdef.length > 3) {
                    replacebyzero = pointdef[3];
                    if (pointdef.length > 4) {
                      decalage = pointdef[4];
                      if (pointdef.length > 5) {
                        filter = pointdef[5];
                      }
                    }
                  }
                }
              }
            }
            let pointname = pointdata?.find((point) => point.pointid == pointid)?.name || "Inconnu";

            currentindex = formulatmp.indexOf("}") + 1;
            formulaprettytmp.push({ type: 'point', id: formulaprettyobjectindex, name: pointname, pointid, agregatg, replacebyzero, decalage, filter, granularity });
            formulaprettyobjectindex++;
            formulatmp = formulatmp.substring(formulatmp.indexOf("}") + 1);
          }
          else {
            updateformulapretty = false;
            break;
          }
        }
        else if (formulatmp.startsWith("{E,")) {
          if (formulatmp.includes("}")) {
            let fullpointdef = formulatmp.substring(formulatmp.indexOf("{E,"), formulatmp.indexOf("}") + 1);
            let pointdef = formulatmp.substring(formulatmp.indexOf("{E,") + 3, formulatmp.indexOf("}")).split(",");
            let pointid;
            let agregatg = 'SUM';
            let replacebyzero = false;
            let decalage;
            let filter;
            let granularity = 'auto';
            if (pointdef.length > 0) {
              pointid = pointdef[0];
              if (pointdef.length > 1) {
                granularity = pointdef[1];
                if (pointdef.length > 2) {
                  agregatg = pointdef[2];
                  if (pointdef.length > 3) {
                    replacebyzero = pointdef[3];
                    if (pointdef.length > 4) {
                      decalage = pointdef[4];
                      if (pointdef.length > 5) {
                        filter = pointdef[5];
                      }
                    }
                  }
                }
              }
            }
            let dataname = dico?.find((def) => def.id == pointid)?.name || "Inconnu";

            currentindex = formulatmp.indexOf("}") + 1;
            formulaprettytmp.push({ type: 'equipmentdatatype', id: formulaprettyobjectindex, name: dataname, pointid, agregatg, replacebyzero, decalage, filter, granularity });
            formulaprettyobjectindex++;
            formulatmp = formulatmp.substring(formulatmp.indexOf("}") + 1);
          }
          else {
            updateformulapretty = false;
            break;
          }
        }
        else if (formulatmp.startsWith("{R,")) {
          if (formulatmp.includes("}")) {
            let pointdef = formulatmp.substring(formulatmp.indexOf("{R,") + 3, formulatmp.indexOf("}")).split(",");
            let pointid;
            let agregatv = 'SUM';
            let replacebyzero = false;
            let searchingroups = false;
            let searchedgroup = "site";
            if (pointdef.length > 0) {
              pointid = pointdef[0];
              if (pointdef.length > 1) {
                replacebyzero = pointdef[1];
                if (pointdef.length > 2) {
                  searchingroups = pointdef[2];
                  if (pointdef.length > 3) {
                    searchedgroup = pointdef[3];
                    if (pointdef.length > 4) {
                      agregatv = pointdef[4];
                    }
                  }
                }
              }
            }
            let pointname = realestatedata?.find((point) => point.id == pointid)?.name || "Inconnu";

            currentindex = formulatmp.indexOf("}") + 1;
            formulaprettytmp.push({ type: 'realestate', id: formulaprettyobjectindex, name: pointname, pointid, agregatv, replacebyzero, searchingroups, searchedgroup });
            formulaprettyobjectindex++;
            formulatmp = formulatmp.substring(formulatmp.indexOf("}") + 1);
          }
          else {
            updateformulapretty = false;
            break;
          }
        }
        else {
          updateformulapretty = false;
          break;
        }
      }
      else {
        formulaprettytmp.push(formulatmp);
        formulatmp = "";
      }
    }
    let newseries = [...series];
    let seriemodif = newseries.find((o) => o.uuid === serie.uuid);
    seriemodif.formula = formula;
    if (updateformulapretty)
      seriemodif.formulapretty = formulaprettytmp;
    if (updateseries)
      setSeries(newseries);
  }

  const editDef = (index, serie) => {
    let obj = serie.formulapretty[index];
    if (obj) {
      setCurrentdef(obj);
      setCurrentFormulapretty(serie.formulapretty);
      setCurrentSerie(serie);
      if (obj.type === 'indic')
        handleClickOpen();
      else if (obj.type === 'point')
        handleClickOpenpoint();
      else if (obj.type === 'realestate')
        handleClickOpenrealestate();
      else if (obj.type === 'equipmentdatatype')
        handleClickOpeneqdatatype();
    }
  }

  const formulaprettyEdited = (newformulapretty, serie) => {
    let formulatmp = "";
    newformulapretty.forEach((items) => {
      if (typeof items === 'object') {
        if (items.type === 'indic') {
          let text = "{I," + items.indicid + "," + items.agregatg + "," + items.replacebyzero;
          if (items.decalage)
            text += "," + items.decalage;
          if (items.filter)
            text += "," + items.filter;
          text += "}";
          formulatmp += text;
        }
        else if (items.type === 'point') {
          let text = "{P," + items.pointid + "," + items.granularity + "," + items.agregatg + "," + items.replacebyzero;
          if (items.decalage)
            text += "," + items.decalage;
          if (items.filter)
            text += "," + items.filter;
          text += "}";
          formulatmp += text;
        }
        else if (items.type === 'equipmentdatatype') {
          let text = "{E," + items.pointid + "," + items.granularity + "," + items.agregatg + "," + items.replacebyzero;
          if (items.decalage)
            text += "," + items.decalage;
          if (items.filter)
            text += "," + items.filter;
          text += "}";
          formulatmp += text;
        }
        else if (items.type === 'realestate') {
          let text = "{R," + items.pointid + "," + items.replacebyzero + "," + items.searchingroups;
          if (items.searchingroups) {
            text += "," + items.searchedgroup + "," + items.agregatv;
          }
          text += "}";
          formulatmp += text;
        }
      }
      else
        formulatmp += items;
    });
    parseFormula(formulatmp, serie, series, true);
  }

  const ExpandableComponent = (props) => {
    const { data } = props;
    let serie = series.find((o) => o.uuid === data.uuid);
    let name = serie.name;
    let formula = serie.formula;
    let color = serie.color;
    let serietype = serie.type;
    let stackId = serie.stackId;
    let yaxis = serie.yaxis;
    let serieagg = serie.serieagg;
    let datatype = serie.datatype;
    let formulapretty = serie.formulapretty || [];
    serie.formulapretty = formulapretty;
    return (
      <GridContainer>
        <GridItem xs={12} sm={12} md={5} lg={5}>
          <div>
            <TextInputUn
              inputTitle={charttext.seriename}
              textInput={name}
              value={serie.name}
              handleTextInputChange={(event) => handleSerieNameChange(event, serie)}
            />
          </div>
        </GridItem>

        {(type !== 'tab' && type !== 'tabequipment') ?
          <GridItem xs={12} sm={12} md={5} lg={5}>
            <div>
              <CustomSelect
                inputTitle={charttext.color}
                selectValue={color}
                handleSelectValueChange={(event) => handleColorChange(event, serie)}
                data={chartcolors}
              />
            </div>
          </GridItem>
          :
          <>
            {
              (type !== 'heatmap') ?
                <>
                  <GridItem xs={12} sm={12} md={5} lg={5}>
                    <div>
                      <CustomSelect
                        inputTitle={charttext.serieagg}
                        selectValue={serieagg}
                        handleSelectValueChange={(event) => handleSerieAggChange(event, serie)}
                        data={serieaggdata}
                      />
                    </div>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={5} lg={5}>
                    <div>
                      <CustomSelect
                        inputTitle={charttext.datatype}
                        selectValue={datatype}
                        handleSelectValueChange={(event) => handleDatatypeChange(event, serie)}
                        data={datatypedata}
                      />
                    </div>
                  </GridItem></> : <></>
            }
          </>
        }
        {((type === 'columnchart' || type === 'linechart' || type === 'areachart' || type === 'composedchart') && yaxis2) ?
          <GridItem xs={12} sm={12} md={3} lg={3}>
            <div>
              <CustomSelect
                inputTitle={charttext.axis}
                selectValue={yaxis}
                handleSelectValueChange={(event) => handleAxisChange(event, serie)}
                data={chartaxisData}
              />
            </div>
          </GridItem>
          : <></>
        }
        {(type === 'composedchart') ?
          <GridItem xs={12} sm={12} md={3} lg={3}>
            <div>
              <CustomSelect
                inputTitle={charttext.serietype}
                selectValue={serietype}
                handleSelectValueChange={(event) => handleSerieTypeChange(event, serie)}
                data={typescomposedchart}
              />
            </div>
          </GridItem>
          : <></>
        }
        {(type === 'indicatorchart') ?
          <GridItem xs={12} sm={12} md={3} lg={3}>
            <div>
              <CustomSelect
                inputTitle={charttext.serietype}
                selectValue={serietype}
                handleSelectValueChange={(event) => handleSerieTypeChange(event, serie)}
                data={indicatorserietypedata}
              />
            </div>
          </GridItem>
          : <></>
        }
        {(type === 'columnchart' || (type === 'composedchart' && serietype === 'column')) ?
          <GridItem xs={12} sm={12} md={3} lg={3}>
            <div>
              <TextInputUn
                inputTitle={charttext.stack}
                textInput={stackId}
                value={serie.stack}
                handleTextInputChange={(event) => handleSerieStackChange(event, serie)}
              />
            </div>
          </GridItem>
          : <></>
        }

        <GridItem xs={12} sm={12} md={10} lg={10}>
          <div>
            <TextInputUn
              inputTitle={charttext.formule}
              textInput={formula}
              handleTextInputChange={(event) => handleFormulaChange(event.target.value, serie)}
              multiline
              rows={2}
              maxLength={2500}
            />
          </div>
        </GridItem>
        <GridItem xs={12} sm={12} md={2} lg={2}>
          <UploadButton type="button">
            <AddValueToFormula
              formula={serie.formula}
              setFormula={handleFormulaChange}
              serie={serie}
              indicatordata={indicatordata}
              pointdata={pointdata}
              realestatedata={realestatedata}
              avalaibleDico={avalaibleDico}
              charttype={type}
              equipmentdatatype={equipmentdatatype}
            />
          </UploadButton>
        </GridItem>
        <GridItem xs={12} sm={12} md={10} lg={10}>
          <FormulaDiv>
            {
              formulapretty.map((items, index) => {
                if (typeof items === 'object') {
                  return <Tooltip title={items.name}><Chip variant="outlined" label={items.name} className={classes.indicatorchip} onClick={() => editDef(index, serie)} /></Tooltip>
                }
                else
                  return <FormulaText>{items}</FormulaText>;
              })
            }

          </FormulaDiv>
        </GridItem>
        <div style={{ height: "1.1rem" }}></div>
      </GridContainer >);
  };

  const [resetPaginationToggleChart, setResetPaginationToggleChart] = useState(false);
  const subHeaderComponentMemoChart = useMemo(() => {
    const handleClearChart = () => {
    };
    return (
      <>
        <TableName>Séries du graphique</TableName>
        <UploadButton type="button" onClick={handleClearChart}>
          <Tooltip title="Ajouter une série">
            <EditButton
              onClick={addSerieToChartFunction}
              color={"success"}
              className={classes2.actionButton}
              disabled={(type === 'heatmap' && series.length > 0) || series.length > 19}
            >
              <AddIcon fontSize="large" />
            </EditButton>
          </Tooltip>
        </UploadButton>
      </>
    );
  }, [series, type]);



  return (
    <>
      <CustomDialogTitle id="customized-dialog-title" onClose={closeModal}>
        {(currentusertype == 1 && currentchart?.id) ? 'Edition du graphique ' + name + " (" + currentchart.id + ")" : 'Edition du graphique ' + name}
      </CustomDialogTitle>
      <DialogContent dividers style={{ height: "90vh" }}>
        <TabContext value={value} className={classes.root}>
          <div className={classes.demo2}>
            <AppBar
              position="static"
              className={classes.demo3}
              style={{ boxShadow: "none", shadowColor: "red" }}
            >
              <StyledTabs
                value={value}
                onChange={handleChange}
                aria-label="styled tabs example"
                scrollButtons="auto"
              >
                <StyledTab label="Paramètres généraux" value="0" />
                <StyledTab label="Séries" value="1" />
              </StyledTabs>
              <Typography className={classes.padding} />
            </AppBar>
            <Divider variant="fullWidth" />
            <TabPanel value="0">
              <form className={classes.root}>
                <GridContainer>
                  <GridItem xs={12} sm={6} md={4} lg={4}>
                    <TreeLabel>{charttext.params}</TreeLabel>
                    <div className={classes.gridListParam}>
                      <div>
                        <TextInput
                          inputTitle={charttext.name}
                          textInput={name}
                          handleTextInputChange={handleNameChange}
                        />
                      </div>
                      <div>
                        <TextInputUn
                          inputTitle={charttext.tooltip}
                          textInput={tooltip}
                          handleTextInputChange={(event) => handleTooltipChange(event.target.value)}
                          multiline
                          rows={5}
                          maxLength={250}
                        />
                      </div>
                      <div>
                        <CustomSwitch
                          style={{ margin: "0.5rem 0rem 0.5rem 1rem" }}
                          inputTitle={charttext.timechart}
                          checkedState={xaxisscale === 'time' ? true : false}
                          handleSwitchChange={handleXaxisscaleChange}
                        />
                      </div>
                      <div>
                        <CustomSelect
                          inputTitle={charttext.type}
                          selectValue={type}
                          handleSelectValueChange={handleTypeChange}
                          //  data={(source && source === 'point') ? charttypepointData : charttypefullData}
                          data={xaxisscale === 'time' ? typestimedata : typesnotimedata}
                        />
                      </div>
                      {
                        (type !== 'tabequipment' && type !== 'heatmap') ?
                          <div>
                            <CustomSelect
                              inputTitle={charttext.distribution}
                              selectValue={distribution}
                              handleSelectValueChange={handleDistributionChange}
                              data={distributiondata}
                            />
                          </div> : <></>
                      }

                      {
                        (distribution && distribution !== 'no') ?
                          <div>
                            <CustomSelect
                              inputTitle={charttext.distributiongroupment}
                              selectValue={distributiongroupment}
                              handleSelectValueChange={handleDistributiongroupmentChange}
                              data={distributiongroupmentdata[distribution]}
                            />
                          </div> : <></>
                      }

                    </div>
                  </GridItem>
                  <GridItem xs={12} sm={6} md={4} lg={4}>
                    <TreeLabel>{charttext.typeparams + " " + typesdata.find((data) => data.id === type).name}</TreeLabel>
                    <div className={classes.gridListParam}>
                      {
                        type === 'indicatorchart' ?
                          <>
                            <div>
                              <TextInput
                                inputTitle={charttext.unit}
                                textInput={yaxis1unit}
                                handleTextInputChange={handleYaxis1unitChange}
                              />
                            </div>
                            <div>
                              <CustomSwitch
                                style={{ margin: "0.5rem 0rem 0.5rem 1rem" }}
                                inputTitle={charttext.lowerisbetter}
                                checkedState={lowerisbetter}
                                handleSwitchChange={handleLowerisbetterChange}
                              />
                            </div>
                            <div>
                              <IntInput
                                inputTitle={charttext.gaugemin}
                                intInput={gaugemin}
                                handleIntInputChange={handleGaugeminChange}
                              />
                            </div>
                            <div>
                              <IntInput
                                inputTitle={charttext.gaugemax}
                                intInput={gaugemax}
                                handleIntInputChange={handleGaugemaxChange}
                              />
                            </div>
                            <div>
                              <IntInput
                                inputTitle={charttext.gaugesegmentscount}
                                intInput={gaugesegmentscount}
                                handleIntInputChange={handleGaugesegmentscountChange}
                                max={9}
                                min={2}
                              />
                            </div>
                            {
                              gaugesegments.map((segment, index) =>
                                <>
                                  <Separator />
                                  <div>
                                    <IntInput
                                      inputTitle={charttext.gaugesegment + " " + (index + 1) + " " + charttext.gaugesegmentmin}
                                      intInput={segment.min}
                                      handleIntInputChange={(event) => handleGaugesegmentsChange(event, index, 'min')}
                                    />
                                  </div>
                                  <div>
                                    <IntInput
                                      inputTitle={charttext.gaugesegment + " " + (index + 1) + " " + charttext.gaugesegmentmax}
                                      intInput={segment.max}
                                      handleIntInputChange={(event) => handleGaugesegmentsChange(event, index, 'max')}
                                    />
                                  </div>
                                  <div>
                                    <CustomSelect
                                      inputTitle={charttext.gaugesegment + " " + (index + 1) + " " + charttext.gaugesegmentcolor}
                                      selectValue={segment.color}
                                      handleSelectValueChange={(event) => handleGaugesegmentsChange(event, index, 'color')}
                                      data={chartcolors}
                                    />
                                  </div>
                                  <div>
                                    <TextInput
                                      inputTitle={charttext.gaugesegment + " " + (index + 1) + " " + charttext.gaugesegmentname}
                                      textInput={segment.name}
                                      handleTextInputChange={(event) => handleGaugesegmentsChange(event, index, 'name')}
                                    />
                                  </div>
                                  <div>
                                    <TextInput
                                      inputTitle={charttext.gaugesegment + " " + (index + 1) + " " + charttext.gaugesegmentshortname}
                                      textInput={segment.shortname}
                                      handleTextInputChange={(event) => handleGaugesegmentsChange(event, index, 'shortname')}
                                    />
                                  </div>
                                </>
                              )
                            }
                          </> : type === 'tab' ?
                            <>
                              <div>
                                <CustomSwitch
                                  style={{ margin: "0.5rem 0rem 0.5rem 1rem" }}
                                  inputTitle={charttext.displaytotal}
                                  checkedState={displaytotal}
                                  handleSwitchChange={handleDisplaytotalChange}
                                />
                              </div>
                            </>
                            : type === 'tabequipment' ?
                              <>
                                <EquipmentsDiv>
                                  <EquipmentsLabel>
                                    {targetequipments.length + charttext.selectedequipments}
                                  </EquipmentsLabel>
                                  <Tooltip title="Choisir les équipements">
                                    <EditButton
                                      onClick={editEquipments()}
                                      color={"warning"}
                                      className={classes2.actionButton}
                                      disabled={equipmentdata.length === 0}
                                    >
                                      <EditIcon fontSize="large" />
                                    </EditButton>
                                  </Tooltip>
                                </EquipmentsDiv>
                              </>
                              : <></>

                      }
                      {type === 'heatmap' ?
                        <>
                          <div>
                            <TextInput
                              inputTitle={charttext.unit}
                              textInput={yaxis1unit}
                              handleTextInputChange={handleYaxis1unitChange}
                            />
                          </div>
                          <div>
                            <CustomSelect
                              inputTitle={charttext.heatmapdisplay}
                              selectValue={heatmapdisplay}
                              handleSelectValueChange={handleHeatmapdisplayChange}
                              data={heatmapdisplaydata}
                            />
                          </div>
                          <div>
                            <CustomSelect
                              inputTitle={charttext.heatmapcolor}
                              selectValue={heatmapcolor}
                              handleSelectValueChange={handleHeatmapcolorChange}
                              data={heatmapcolordata}
                            />
                          </div>
                        </>
                        :
                        (xaxisscale === 'time' || type === 'columnchart') &&
                        <>

                          <div>
                            <TextInput
                              inputTitle={charttext.leftaxisunit}
                              textInput={yaxis1unit}
                              handleTextInputChange={handleYaxis1unitChange}
                            />
                          </div>
                          <div>
                            <CustomSwitch
                              style={{ margin: "0.5rem 0rem 0.5rem 1rem" }}
                              inputTitle={charttext.rightaxis}
                              checkedState={yaxis2}
                              handleSwitchChange={handleYaxis2Change}
                            />
                          </div>
                          {yaxis2 ?
                            <div>
                              <TextInput
                                inputTitle={charttext.rightaxisunit}
                                textInput={yaxis2unit}
                                handleTextInputChange={handleYaxis2unitChange}
                              />
                            </div> : <></>}
                          {
                            (xaxisscale === 'time') ?
                              <>
                                <div>
                                  <CustomSelect
                                    inputTitle={charttext.granularity}
                                    selectValue={granularity}
                                    handleSelectValueChange={handleGranularityChange}
                                    data={granularitydata}
                                  />
                                </div>
                                <div>
                                  <CustomSwitch
                                    style={{ margin: "0.5rem 0rem 0.5rem 1rem" }}
                                    inputTitle={charttext.defaultoccupationschedule}
                                    checkedState={defaultoccupationschedule}
                                    handleSwitchChange={handleDefaultoccupationscheduleChange}
                                  />
                                </div>
                              </> : <></>
                          }
                        </>
                      }
                    </div>
                  </GridItem>
                  <GridItem xs={12} sm={6} md={4} lg={4}>
                    <div
                      className={classes.treeVisible}
                    >
                      <TreeLabel>{charttext.visibility}</TreeLabel>
                      <ImageList rowHeight={140} className={classes.gridList} cols={1}>
                        <EmbeddedEntitesTree
                          selectedIds={setGroups}
                          userSelectedIds={groups}
                          filterfromnode={"" + chartIdGroup[0]}
                        />
                      </ImageList>
                    </div>
                  </GridItem>
                </GridContainer>

              </form>
            </TabPanel>
            <TabPanel value="1">
              <Container>

                <DataTable
                  paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
                  noDataComponent={<NoData>{"Aucune série"}</NoData>}
                  noHeader={true}
                  columns={seriesColumns}
                  persistTableHead
                  pagination
                  subHeader
                  data={series}
                  paginationComponentOptions={{
                    noRowsPerPage: false,
                    rowsPerPageText: "Lignes par page",
                    rangeSeparatorText: "sur",
                    selectAllRowsItem: false,
                    selectAllRowsItemText: "Selectionner toutes les lignes",
                  }}
                  defaultPageSize={10}
                  filterable={true}
                  defaultSortFieldId={1}
                  manual={true}
                  paginationResetDefaultPage={setResetPaginationToggleChart}
                  subHeaderComponent={subHeaderComponentMemoChart}
                  expandOnRowClicked
                  expandableRows
                  expandableRowDisabled={(row) => row.disabled}
                  expandableRowsComponent={ExpandableComponent}
                />

              </Container>
            </TabPanel>
          </div>

        </TabContext>
      </DialogContent>
      <DialogActions>
        <Button
          disabled={buttonDisabled}
          className={
            buttonDisabled
              ? classes.submitButtonDisabled
              : classes.submitButton
          }
          onClick={() => {
            handleSubmit();
          }}
        >
          Enregistrer
        </Button>
      </DialogActions>
      <Dialog
        onClose={handleEditClose}
        aria-labelledby="edituser-dialog-title"
        fullWidth="true"
        maxWidth="md"
        open={open}
      >
        <CustomDialogTitle id="customized-dialog-title" onClose={handleEditClose}>
          {"Paramètres de l'indicateur " + currentdef.name}
        </CustomDialogTitle>
        <DialogContent dividers>
          <AdvancedDefDialogIndic
            closeModal={handleEditClose}
            def={currentdef}
            formulapretty={currentFormulapretty}
            formulaprettyEdited={formulaprettyEdited}
            serie={currentSerie}
            charttype={type}
          />
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>
      <Dialog
        onClose={handleEditClosepoint}
        aria-labelledby="edituser-dialog-title"
        fullWidth="true"
        maxWidth="md"
        open={openpoint}
      >
        <CustomDialogTitle id="customized-dialog-title" onClose={handleEditClosepoint}>
          {"Paramètres du point " + currentdef.name}
        </CustomDialogTitle>
        <DialogContent dividers>
          <AdvancedDefDialogPoint
            closeModal={handleEditClosepoint}
            def={currentdef}
            formulapretty={currentFormulapretty}
            formulaprettyEdited={formulaprettyEdited}
            graphgranularity={granularity}
            serie={currentSerie}
            charttype={type}
          />
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>
      <Dialog
        onClose={handleEditCloseeqdatatype}
        aria-labelledby="edituser-dialog-title"
        fullWidth="true"
        maxWidth="md"
        open={openeqdatatype}
      >
        <CustomDialogTitle id="customized-dialog-title" onClose={handleEditCloseeqdatatype}>
          {"Paramètres du type de donnée " + currentdef.name}
        </CustomDialogTitle>
        <DialogContent dividers>
          <AdvancedDefDialogEquipmentDatatype
            closeModal={handleEditCloseeqdatatype}
            def={currentdef}
            formulapretty={currentFormulapretty}
            formulaprettyEdited={formulaprettyEdited}
            graphgranularity={granularity}
            serie={currentSerie}
            charttype={type}
          />
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>
      <Dialog
        onClose={handleEditCloserealestate}
        aria-labelledby="edituser-dialog-title"
        fullWidth="true"
        maxWidth="md"
        open={openrealestate}
      >
        <CustomDialogTitle id="customized-dialog-title" onClose={handleEditCloserealestate}>
          {"Paramètres de la valeur " + currentdef.name}
        </CustomDialogTitle>
        <DialogContent dividers>
          <AdvancedDefDialogRealestate
            closeModal={handleEditCloserealestate}
            def={currentdef}
            formulapretty={currentFormulapretty}
            formulaprettyEdited={formulaprettyEdited}
            serie={currentSerie}
            charttype={type}
          />
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>
      <Dialog
        onClose={handleCloseEquipments}
        aria-labelledby="addMarket-dialog-title"
        fullWidth={true}
        maxWidth="md"
        open={openEquipments}
      >
        <CustomDialogTitle id="addMarket-dialog-title" onClose={handleCloseEquipments}>
          Equipements concernés
        </CustomDialogTitle>
        <DialogContent dividers>
          <EquipmentsDialog
            closeModal={handleCloseEquipments}
            equipmentsData={equipmentdata}
            equipments={targetequipments}
            setEquipments={setTargetequipments}
            fullpointdata={fullpointdata}
            setEquipmentatatype={setEquipmentatatype}
          />
        </DialogContent>
        <DialogActions />
      </Dialog>
    </>
  );
}

export default ChartDialogV2;
